// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lsux-marketing-footer--light{background-color:var(--n100)}`, "",{"version":3,"sources":["webpack://./src/components/App/App.scss"],"names":[],"mappings":"AAAA,8BACE,4BAAA","sourcesContent":[".lsux-marketing-footer--light {\n  background-color: var(--n100);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
